module.exports = __webpack_public_path__ + "static/media/UploadBlue.d1b759ab.svg";